'use strict';

const FLEX_WINDOW_KEY = "__FLEX__";
const FLEX_WINDOW_GLOBAL_CONTEXTS_KEY = "global-contexts";

exports.FLEX_WINDOW_GLOBAL_CONTEXTS_KEY = FLEX_WINDOW_GLOBAL_CONTEXTS_KEY;
exports.FLEX_WINDOW_KEY = FLEX_WINDOW_KEY;
//# sourceMappingURL=windowFlex.cjs.map
